import { Injectable } from '@angular/core';
import { WebRTCAdaptor } from '@antmedia/webrtc_adaptor';
import { Capacitor } from '@capacitor/core';
import { ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import log from 'video.js/dist/types/utils/log';

@Injectable({ providedIn: 'root' })
export class VideoService {
  adaptor!: any;
  localStreamId!: string;
  localFacingMode!: string;
  localStream: MediaProvider | null = null;
  cameraStream: MediaStream | null = null;
  webRTCAdaptor!: any;
  isIos = false;
  private stopMiniVideoSubject = new Subject<void>();
  stopMiniVideo$ = this.stopMiniVideoSubject.asObservable();

  constructor(private modalCtrl: ModalController){
    const isNativeApp = Capacitor.isNativePlatform();
    const isIOS = Capacitor.getPlatform() === 'ios';
    if (isNativeApp && isIOS) {
        this.isIos = true;
    }
  }

  stopMiniVideo() {
    this.stopMiniVideoSubject.next();
  }

  async forceCloseLiveStream() {
    const modal = await this.modalCtrl.getTop();
    if (modal) await modal.dismiss();
    this.stopMiniVideo();
    this.stop();
  }

  async init(localVideo: HTMLVideoElement, url: string, streamId: string, facingMode: string) {
    if (!this.adaptor) {
      console.log("VideoService URL:", url);
      this.localStreamId = streamId;
      console.log("Video Service:", this.localStreamId);
      this.localFacingMode = facingMode;
      this.adaptor = new WebRTCAdaptor({
        websocket_url: url,
        localVideoElement: localVideo,
        mediaConstraints: {
            video: {
                facingMode: { exact: facingMode } 
            },
            audio: true
        },
        peerconnection_config: {
            iceServers: [
                { urls: "stun:stun.l.google.com:19302" },
                { urls: "turn:172.188.59.133:3478", username: "azureuser", credential: "B4t3Array123#" }
            ]
        },
        sdp_constraints: { OfferToReceiveAudio: false, OfferToReceiveVideo: false },
        callback: (info: string, obj: any) => {
            console.log('WebRTC callback:', info);
            if (info === "initialized") {
                if(!this.isIos){
                    this.startCamera(localVideo);
                }
                this.adaptor.localVideoElement = 
                console.log("Publishing with streamId:", this.localStreamId);
                this.adaptor.publish(this.localStreamId);
                localVideo.muted = true;
                localVideo.volume = 0;
            }

            if (info === "publish_started") {
                console.log("publish_started:", this.adaptor.localStream);
                this.localStream = localVideo.srcObject;
            }
        },
        callbackError: (error: any) => {
            console.error('WebRTC error:', error);
        }
      });
    } else {
        if(!this.isIos){
           
        }
         this.startCamera(localVideo);
    }
  }

  stop() {
    if(this.adaptor) {
        console.log("localstreamID stop:", this.localStreamId);
        this.adaptor.stop(this.localStreamId);
        this.adaptor.closeStream();
        //this.adaptor.turnOffCamera();
        this.adaptor.closeWebSocket();
        this.adaptor = null;
        if (this.cameraStream) {
            this.cameraStream.getTracks().forEach(track => track.stop()); // stops video & audio tracks
            this.cameraStream = null;
        }
    }
    
  }

  switchCamera(){
    if(this.adaptor){
        if(this.localFacingMode == 'user'){
            this.localFacingMode = 'environment';
        } else {
            this.localFacingMode = 'user';
        }
        this.adaptor.switchVideoCameraFacingMode( this.localStreamId, this.localFacingMode);
    }
  }

  async startCamera(videoEl: HTMLVideoElement) {
    try {
        if(this.isIos){
            videoEl.srcObject = this.localStream;
        } else {
            this.cameraStream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: this.localFacingMode }, // or "environment"
            audio: false
            });
            videoEl.srcObject = this.cameraStream;
        }
        
    } catch (err) {
        console.error("Error accessing camera", err);
    }
  }

  async switchPreviewCamera(videoEl: HTMLVideoElement) {
    try {

        if(this.cameraStream){
            const currentTrack = this.cameraStream.getVideoTracks()[0];
            if(currentTrack){
                this.cameraStream.removeTrack(currentTrack);
            }
            currentTrack.stop();

            this.cameraStream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: this.localFacingMode }, // or "environment"
                audio: false
            });
            videoEl.srcObject = this.cameraStream;
        }
    } catch (err) {
        console.error("Error accessing camera", err);
    }
  }

  async stopPreviewCamera(videoEl: HTMLVideoElement) {
    try {
        if (this.cameraStream) {
           navigator.mediaDevices.enumerateDevices().then(devices => {
            devices
                .filter(d => d.kind === 'videoinput')
                .forEach(() => {
                if (this.cameraStream) {
                    this.cameraStream.getTracks().forEach(track => track.stop());
                }
                });
            });
        }
        videoEl.srcObject = null;

    } catch (err) {
        console.error("Error accessing camera", err);
    }
  }

  async play(videoEl: HTMLVideoElement, url: string, streamId: string) {
    console.log("VideoService URL:", url);
    this.localStreamId = streamId;
    console.log("Video Service:", this.localStreamId);
    console.log("VvideoEl:", videoEl);
    this.webRTCAdaptor = new WebRTCAdaptor({
        websocket_url: url,
        remoteVideoElement: videoEl,
        isPlayMode: true,
        peerconnection_config: {
                iceServers: [
                { urls: "stun:stun.l.google.com:19302" },
                { urls: "turn:172.188.59.133:3478", username: "azureuser", credential: "B4t3Array123#" }
                ]
            },
        callback: (info: any, obj: any) => {
            // console.log("callback info: " + info);
            if (info === "initialized") {
                this.webRTCAdaptor.play(streamId);
                }
            if (info == "play_started") {
                console.log("publish started");
                // statusInfo.innerHTML = "Playing - Stream Id:" + streamId; 
            }
            else if (info == "play_finished") {
                console.log("publish finished")
                // statusInfo.innerHTML = "Offline"
            }
        },
    
    });
  }
}
